import styled from "styled-components"

import { CONTENT_MAX_WIDTH, MEDIA_QUERIES } from "@constants"

export const ContentImagesFIGURE = styled.figure`
  display: grid;
  gap: var(--spacing--M);
  margin: var(--spacing--S) auto var(--spacing--M);
  width: 100%;

  .has-caption & {
    margin-bottom: var(--spacing--XS);
  }
  
  .gatsby-image-wrapper {
    -webkit-transform: translate3d(0, 0, 0); /* safari border fix */
    border-radius: var(--border-radius--M); 
    display: block !important;
    margin: 0 auto;


    [data-main-image] {
      height: 100%;
    }
  }

  & + .ContentCaption {
    margin-bottom: var(--spacing--M);
  }

  img {
    width: 100%;
    height: auto;
  }

  /* ======== SINGLE LAYOUT ======== */
  &.layout--SINGLE {
    max-width: ${CONTENT_MAX_WIDTH}px;
  }

  &.layout--SINGLE,
  &.layout--SINGLE_WIDE {
    grid-template-columns: 1fr;
  }

  &.layout--SINGLE_WIDE {
    max-width: none;
  }

  /* ======== TWO_UP LAYOUT ======== */
  &.layout--TWO_UP {
    max-width: ${CONTENT_MAX_WIDTH}px;
  }

  &.layout--TWO_UP,
  &.layout--TWO_UP_WIDE {
    grid-template-columns: 1fr 1fr;
  }
    
  /* ======== THREE_UP LAYOUT ======== */
  &.layout--THREE_UP {
    grid-template-columns: 1fr;

    ${MEDIA_QUERIES.M} {
      grid-template-columns: repeat(12, 1fr);
      grid-template-rows: repeat(2, auto);
    }

    .grid-item-1 {
      display: flex;
      align-items: center; 
      
      ${MEDIA_QUERIES.M} {
        grid-area: 1 / 2 / 3 / 8;
      }
    }

    .grid-item-2 {
      ${MEDIA_QUERIES.M} {
        grid-area: 1 / 8 / 2 / 12;
        display: flex;
        align-items: flex-end;
      }
    }

    .grid-item-3 {
      ${MEDIA_QUERIES.M} {
        grid-area: 2 / 8 / 3 / 11;
      }
    }
  }
`